// SPEC-ANALYTICS-USAGE-SORT-W1-01 (D-068): page_usage_stats 計測 (fn_track_page_usage) + 本人 stats 読み。
import { supabase } from '../lib/supabase'
import { FEATURE_PAGE_KEY_PREFIX } from '../constants/pageKeys'

/**
 * fn_track_page_usage 累積 upsert。計測が UX を壊すの禁止 → 失敗は silent (console.warn のみ、ERR-USAGE-001)。
 */
export async function trackPageUsage({ staffId, pageKey, addViews = 0, addSeconds = 0 }) {
  if (!staffId || !pageKey) return
  try {
    const { error } = await supabase.rpc('fn_track_page_usage', {
      p_staff_id: staffId,
      p_page_key: pageKey,
      p_add_views: addViews,
      p_add_seconds: addSeconds,
    })
    if (error) throw error
  } catch (e) {
    if (typeof console !== 'undefined') console.warn('ERR-USAGE-001 track_page_usage failed (silent):', pageKey, e?.message)
  }
}

/**
 * 本人の page_usage_stats を { [page_key]: { view_count, total_seconds } } で返す。
 * 失敗時は {} (ソートがハブ表示をブロックしない → 既定順)。
 */
export async function fetchMyPageUsage(staffId) {
  if (!staffId) return {}
  try {
    // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
    const { data, error } = await supabase
      .from('page_usage_stats')
      .select('page_key, view_count, total_seconds')
      .eq('staff_id', staffId)
    if (error) throw error
    return Object.fromEntries((data ?? []).map(r => [r.page_key, r]))
  } catch {
    return {}
  }
}

/**
 * SPEC-FEATURE-USAGE-PROBE-V1 (D-524): 機能を 1 回使ったことを記録する。
 *
 * ★fire-and-forget。await しない・例外を投げない・戻り値を見ない。
 *   計測が巡回の保存やナビ起動や OCR を止めてはいけない(AC3)。
 *   trackPageUsage は既に失敗を silent に握るが、それに頼らず呼び出し自体も try で囲む。
 *   supabase が差し替え不能な形で壊れていて同期例外を投げても、ここで止める。
 * ★staffId が無い(未ログイン等)ときは何もしない。trackPageUsage の既存の性質をそのまま使う(AC6)。
 * ★page_key は feat: 接頭辞で名前空間を分ける。滞在秒は持たない概念なので addSeconds は 0。
 */
export function trackFeatureUse(staffId, featureKey) {
  if (!staffId || !featureKey) return
  try {
    Promise.resolve(
      trackPageUsage({
        staffId,
        pageKey: `${FEATURE_PAGE_KEY_PREFIX}${featureKey}`,
        addViews: 1,
        addSeconds: 0,
      })
    ).catch(() => {})
  } catch {
    /* 計測は本業を止めない */
  }
}
